import useSWR from "swr";
import fetcher from "../utils/fetch";
import { RelativeUrl } from "../utils/environment";

type GoogleCTAType = string;

const useGoogleCTATypes = () => {
  const { data, error, isLoading } = useSWR<GoogleCTAType[]>(`${RelativeUrl}/google/call_to_action_types`, fetcher, {
    revalidateIfStale: false // never refetch as settings will rarely change
  });

  return {
    ctaTypes: data || [],
    isLoading,
    error: error ? "Failed to fetch Google CTA types" : null
  };
};

export default useGoogleCTATypes;
